import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProfilePictureDetails from "../../components/admin/ProfilePictureDetails";
import PatientProfileDetails from "../../components/admin/PatientProfileDetails";
import ProfileDetails from "../../components/admin/ProfileDetails";
import { API } from "../../constants/api";
import { PAGE } from "../../constants/page";
import { TestDataAsha } from "../../mock/admin/AdminHome";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { updateBreadcrum } from "../../redux/reducers/BreadcrumbSlice";
import {
  ApiCallWithLoader,
  errorUpdate,
} from "../../redux/reducers/LoaderSlice";
import "../../styles/ViewProfile.scss";
import Utility from "../../utility/Utility";
import { UserState } from "../../redux/reducers/UserSlice";
import { ROLE } from "../../constants/role";
import i18next from "i18next";
import AdminPopUp from "../../components/admin/AdminPopUp";
import { Trans } from "react-i18next";
import SuccessMessage from "src/components/SuccessMessage";
import { ashaAuthIdState } from "src/redux/reducers/AuthAshaDetailsSlice";
import LeydenBanner from "src/components/LeydenBanner";
import AuthService from "src/services/AuthService";

const ViewProfile = () => {
  const locationParams = useParams();
  const { userType, userName } = locationParams;
  const [patientDetails, setPatientDetails] = useState<any>(null);
  const [profilePicDetails, setProfilePicDetails] = useState<any>(null);
  const dispatch = useAppDispatch();
  const userLocation = useLocation();
  const userDetails: any = useAppSelector(UserState);
  const userRole = Utility.getUserRole(
    userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]
  );
  const [showPopUp, setShowPopUp] = useState(false);
  const [actionType, setActionType] = useState("Activate");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const ashaState: any = useAppSelector(ashaAuthIdState);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (userType === "patient") {
      const fetchPatientDetails = async () => {
        try {
          const requestDetails = {
            url: API.PATIENT_DETAILS.replace(
              ":id",
              userLocation?.state?.patientId
            ),
            method: "GET",
          };
          const fetchPatient = await dispatch(
            ApiCallWithLoader(requestDetails)
          );
          setProfilePicDetails({
            name: Utility.patientName(fetchPatient?.payload?.name),
            id: fetchPatient?.payload?.identifier
              ? Utility.getIDNumber(fetchPatient?.payload)
              : "unavailable",
            idType: Utility.getIDString(fetchPatient?.payload),
            age: Utility.getAge(fetchPatient?.payload?.birthDate),
            birthOfDate: fetchPatient?.payload?.birthDate,
            phoneNumber: fetchPatient?.payload?.telecom[0].value,
            gender: fetchPatient?.payload?.gender,
            emergencyList: [],
          });
          setPatientDetails(fetchPatient?.payload);
          updateBreadcrumWithName(
            Utility.patientName(fetchPatient?.payload?.name)
          );
        } catch (error) {
          dispatch(errorUpdate({ isError: true, error: error }));
        }
      };
      fetchPatientDetails();
    } else if (userType === "asha") {
      const fetchAshaDetails = async () => {
        const requestDetails = {
          url: API.GET_USER_DETAILS,
          method: "POST",
          callType: "auth0",
          requestData: {
            userId: userLocation?.state?.authID,
          },
        };

        try {
          const fetchUser = await dispatch(ApiCallWithLoader(requestDetails));
          setProfilePicDetails({
            name: fetchUser?.payload.name,
            id: `${fetchUser?.payload.username}`,
            idType: "ID",
            age: Utility.getAge(fetchUser?.payload?.user_metadata?.birthdate),
            birthOfDate: fetchUser?.payload?.user_metadata?.birthdate,
            phoneNumber: fetchUser?.payload?.app_metadata?.phone_number,
            statusValue: Utility.getStatusValue(
              fetchUser?.payload?.blocked,
              fetchUser?.payload?.app_metadata,
              fetchUser?.payload?.blocked_for
            ),
            userID: fetchUser?.payload?.user_id,
            personalInformation: [
              {
                title: "Marital Status",
                title_key: "myProfile.marital_status",
                data: fetchUser?.payload?.user_metadata?.organizations?.EODB
                  ?.marital_status,
              },
              {
                title: "Husband's Name",
                title_key: "myProfile.husband_name",
                data: fetchUser?.payload?.user_metadata?.organizations?.EODB
                  ?.husband_name,
              },
            ],
            addressInformation: [
              {
                title: "Village/Slum",
                title_key: "myProfile.village_slum",
                data: fetchUser?.payload?.user_metadata?.address?.locality?.split(
                  ","
                )[0],
              },
              {
                title: "District/Block",
                title_key: "myProfile.district_block",
                data: fetchUser?.payload?.user_metadata?.address?.locality?.split(
                  ","
                )[1],
              },
              {
                title: "State",
                title_key: "myProfile.state",
                data: fetchUser?.payload?.user_metadata?.address?.region,
              },
              {
                title: "Pin Code",
                title_key: "myProfile.pinCode",
                data: fetchUser?.payload?.user_metadata?.address?.postal_code,
              },
            ],
            assignInformation: [
              {
                title: "Village",
                title_key: "myProfile.village",
                data: [
                  fetchUser?.payload?.user_metadata?.address?.locality?.split(
                    ","
                  )[0],
                ],
              },
              {
                title: "Sub Centre",
                title_key: "myProfile.subCenter",
                data: [
                  fetchUser?.payload?.user_metadata?.organizations?.EODB
                    ?.sub_center,
                ],
              },
              {
                title: "UHPC/PHC",
                title_key: "myProfile.upch_phc",
                data: [
                  fetchUser?.payload?.user_metadata?.organizations?.EODB
                    ?.uphcPhc,
                ],
              },
            ],
          });
          updateBreadcrumWithName(fetchUser?.payload.name);
        } catch (error) {}
      };
      fetchAshaDetails();
    } else if (userType === "admin") {
      const fetchAdminDetails = async () => {
        const requestDetails = {
          url: API.GET_USER_DETAILS,
          method: "POST",
          callType: "auth0",
          requestData: {
            userId: userLocation?.state?.authID,
          },
        };

        try {
          const fetchUser = await dispatch(ApiCallWithLoader(requestDetails));

          const stateName =
            fetchUser?.payload?.user_metadata?.address?.region.replace(
              / /g,
              "_"
            );
          const requestDistrictDetails = {
            url: API.DISTRICTS_BY_STATE.replace(":stateName", stateName),
            method: "GET",
          };
          const resp = await dispatch(
            ApiCallWithLoader(requestDistrictDetails)
          );
          const districtList = resp.payload?.entry.map((location: any) => {
            return location.resource.name;
          });

          setProfilePicDetails({
            name: fetchUser?.payload.name,
            id: `${fetchUser?.payload.username}`,
            idType: "ID",
            age: Utility.getAge(fetchUser?.payload?.user_metadata?.birthdate),
            birthOfDate: fetchUser?.payload?.user_metadata?.birthdate,
            phoneNumber: fetchUser?.payload?.app_metadata?.phone_number,
            statusValue: Utility.getStatusValue(
              fetchUser?.payload?.blocked,
              fetchUser?.payload?.app_metadata,
              fetchUser?.payload?.blocked_for
            ),
            userID: fetchUser?.payload?.user_id,
            stateDistrictList: [
              {
                title: "State",
                title_key: "state",
                data: fetchUser?.payload?.user_metadata?.address?.region,
              },
              {
                title: "List of Districts (1 District)",
                title_key: "list_of_district",
                data: districtList,
              },
            ],
          });
          updateBreadcrumWithName(fetchUser?.payload.name);
        } catch (error) {
          dispatch(errorUpdate({ isError: true, error: error }));
        }
      };
      fetchAdminDetails();
    } else {
      console.log("Not a valid Route");
    }
  }, []);

  const updateBreadcrumWithName = (name: string) => {
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: userName || "",
            label_key: name || " ",
            path: PAGE.VIEW_USERS,
            id: "view_profile",
            value: "",
          },
        ],
        display: true,
      })
    );
  };

  const changeStatusFromProfile = async () => {
    try {
      const requestDetails = {
        url: API.USER_CHANGE_STATUS,
        method: "POST",
        callType: "auth0",
        requestData: {
          user_id: profilePicDetails?.userID,
          status:
            profilePicDetails?.statusValue === "Inactive" ? "unblock" : "block",
        },
      };
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      if (resp) {
        handlePopUp(false);
        let updatedStatus = Utility.getStatusValue(
          resp.payload.data.blocked,
          resp.payload.data.app_metadata,
          resp?.payload?.blocked_for
        );
        setProfilePicDetails({
          ...profilePicDetails,
          statusValue: updatedStatus,
        });
        setShowSuccessMessage(true);
      }
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };
  const handlePopUp = (value: boolean) => {
    setShowPopUp(value);
  };

  if (!profilePicDetails) {
    return null;
  }
  const editAshaUserLocation = userLocation?.pathname?.includes("editUser");

  return (
    <>
      <div className="bg-light-gray">
        <div className="container viewProfileContainer text-capitalize ">
          <h2>{profilePicDetails?.name}</h2>
        </div>
      </div>
      <div className="container elsReset">
        {showSuccessMessage ? (
          <SuccessMessage
            ashaActivateDectivate={profilePicDetails.name}
            statusVal={
              profilePicDetails?.statusValue?.toLocaleLowerCase() === "active"
                ? "activated"
                : "deactivated"
            }
            page="viewProfile"
          />
        ) : null}
        <div className="mb-3">
          {ashaState?.updatedAsha?.updated === true &&
          ashaState.viewSuccessBannerOnDetils ? (
            <LeydenBanner
              children="Profile has been updated successfully"
              onIconClose={() => {
                setShowAlert(false);
              }}
            />
          ) : null}
        </div>
        <ProfilePictureDetails
          userName={profilePicDetails?.name}
          idDetails={profilePicDetails?.id?.toUpperCase()}
          idType={profilePicDetails.idType}
          age={Utility.getAge(profilePicDetails?.birthOfDate)}
          birthOfDate={profilePicDetails?.birthOfDate}
          phoneNumber={profilePicDetails?.phoneNumber
            ?.toString()
            .padStart(13, "+91")}
          userType={userType}
          gender={profilePicDetails?.gender}
          status={profilePicDetails?.statusValue}
          userId={userLocation?.state?.authID}
          userLocation={userLocation?.pathname}
          userRole={userLocation?.state?.userRole}
        />
        {userType === "patient" && (
          <PatientProfileDetails patientDetails={patientDetails} />
        )}
        {userType === "asha" && (
          <>
            {/*     <ProfileDetails
              profileTitle="Personal Information"
              title_key="myProfile.personal_info"
              contentData={profilePicDetails?.personalInformation}
            /> */}
            <ProfileDetails
              profileTitle="Address"
              title_key="myProfile.address"
              contentData={profilePicDetails?.addressInformation}
            />
            <ProfileDetails
              profileTitle="Assigned Locations"
              title_key="myProfile.assign_location"
              contentData={profilePicDetails?.assignInformation}
            />
          </>
        )}
        {userType === "admin" && (
          <>
            <ProfileDetails
              profileTitle="State and Districts"
              title_key="state_and_disctricts"
              isStateAdmin={true}
              contentData={profilePicDetails?.stateDistrictList}
            />
          </>
        )}
      </div>
      <AdminPopUp
        show={showPopUp}
        handelClose={() => {
          handlePopUp(false);
        }}
        handleOnSubmit={() => {
          changeStatusFromProfile();
        }}
        title_key={`${actionType}_user`}
        body={
          <>
            <Trans i18nKey={"are_you_sure_you_want"} />{" "}
            <span className="text-capitalize">
              <Trans i18nKey={actionType?.toLowerCase()} />
            </span>{" "}
            <b>{profilePicDetails.name}</b>?
          </>
        }
        primaryButtonTitle_key={actionType}
        secondaryButtonTitle_key="cancel"
      />
    </>
  );
};

export default ViewProfile;
